import React, { Component } from 'react'

export default class HowItWorks extends Component {
    render() {
        return (
            <div className="container">
                <h1 class="center-align">Infos Zum Spiel</h1>
                <p>Banden-Bingo ist klassisches Bingo – in der Eishockey-Version. Das Besondere:
                    Die Gewinnzahlen werden durch Bandenberührungen der Spieler ermittelt.</p>
                <br />
                <p>SO FUNKTIONIERTS</p>
                <p>1. Gib Banden-Bingo Deinen Standort frei oder wähle später, ob du im Stadion 
                    oder zu Hause spielst. Je nachdem kannst du ein möglicher Gewinn gleich im Stadion einlösen oder kannst ihn Dir nach Hause senden lassen.</p>
                <p>2. Wähle Deine Bingo-Karte.</p><p>3. Registriere Dich als Spieler. Bei einer weiteren Spielteilnahme musst Du Dich nur noch einloggen.</p>
                <p>4. Schon geht’s los. Während des Eishockey- Spiels unbedingt Zahlen der Banden- Berührungen auf deiner Bingo-Karte markieren.</p>
                <p>5. Sobald eine waagerechte, senkrechte oder diagonale Reihe vollständig ausgefüllt ist und alle Zahlen richtig eingetragen sind, hast Du „BINGO“.
                Je schneller du „BINGO“ hast, desto höher sind Deine Gewinn-Chancen. Denn die Gewinner werden der Reihe nach ermittelt. Der erster Teilnehmer der 
                „BINGO“ hat gewinnt den 1. Preis, der zweite Teilnehmer den 2. und so weiter. Viel Glück!</p>
                <p>6. Gewinn einlösen: mit dem Code, den Du bei „BINGO“ direkt auf Dein Mobilephon bekommst kannst Du den Gewinn sofort einlösen. Spielst Du nicht 
                    im Stadion, kannst Du Dir den Gewinn auch nach Hause senden lassen.</p>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/HowItWorks.jsx